import React from 'react';
import { Select } from 'antd';
import { FilterGroup, FilterLabel } from '../Styles';
import type { SelectOption } from '../hooks/useSelectOptions';

interface FilterSelectProps<T extends string> {
  label: string;
  placeholder: string;
  options: SelectOption[] | readonly { value: T; label: string }[];
  value?: T;
  onChange: (value?: T) => void;
  loading?: boolean;
  /** Off for short, fixed enums (status) where a search box is noise. */
  searchable?: boolean;
  minWidth?: number;
}

/**
 * A labelled, clearable filter dropdown.
 *
 * Every filter row in this feature is the same `FilterGroup` + `FilterLabel` +
 * `Select` triple; only the label, placeholder, width and option source differ.
 */
const FilterSelect = <T extends string>({
  label,
  placeholder,
  options,
  value,
  onChange,
  loading,
  searchable = true,
  minWidth = 200,
}: FilterSelectProps<T>) => (
  <FilterGroup>
    <FilterLabel>{label}</FilterLabel>
    <Select<T>
      allowClear
      showSearch={searchable}
      optionFilterProp="label"
      placeholder={placeholder}
      style={{ minWidth }}
      loading={loading}
      value={value}
      onChange={onChange}
      options={options as SelectOption[]}
    />
  </FilterGroup>
);

export default FilterSelect;
